import React from "react";
//#region types
import { SupportStatusTagsProps } from "models/propTypes/supportPropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
import { useSupportService } from "serviceHooks";
//#endregion

const SupportStatusTags: React.FC<SupportStatusTagsProps> = (props) => {
  const supportService = useSupportService();
  // The prop is named status for backward compatibility with existing callers; the service
  // functions below key off the SupportIssue field name (state) instead.
  const agencyAwareState = {
    state: props.status,
    isLocked: props.isLocked ?? false,
    isOwnedByAgency: props.isOwnedByAgency ?? false,
    isViewerAgencyMember: props.isViewerAgencyMember ?? false,
  };

  return (
    <Tags
      tags={[supportService.getAgencyAwareStateText(agencyAwareState)]}
      className={supportService.getAgencyAwareStateLabelClass(agencyAwareState)}
    />
  );
};

export default SupportStatusTags;
